/* eslint-disable camelcase */
export interface Company {
  id: number | null
  display_name?: string
  image_logo?: string
  slug: string
  detail_url: string
  is_followed: boolean
  tagline: string
  website: string
  image_galleries: any
  num_job_openings?: number;
  benefits: any
  recruitment_process?: any[]
  faqs?: any;
  products?: any;
  news?: any;
}
export interface Addresses {
  address_region_ids?: string[]
  address_region_list?: string
  address_region_array?: string[]
  full_addresses?: string[]
  sort_addresses?: string
  collection_addresses?: string[]
}
export interface DateType {
  date: string
  datetime: string
  since: string
}
export interface Salary {
  currency?: string
  unit: string
  min?: any
  max?: any
  value?: string
}
export interface JobTechComBank {
  title?: string
  experiences_ids?: string[]
  job_levels_ids?: string[]
  addresses?: Addresses
  detail_url?: string
  salary?: Salary
  image_thumbnail?: string
}

export interface Job {
  meta_description?: any
  meta_keywords?: any
  meta_title?: any
  id?: string | number | null
  title?: string
  content?: string
  benefits?: string[]
  requirements?: string
  responsibilities?: string
  recruiment_process?: string[]
  company?: Company
  extra_skills?: string[]
  skills_str?: string
  skills_arr?: string[]
  skills_ids?: string[]
  experiences_str?: string
  experiences_arr?: string[]
  experiences_ids?: string[]
  job_types_str?: string
  job_types_arr?: string[]
  job_types_ids?: string[]
  job_levels_str?: string
  job_levels_arr?: string[]
  job_levels_ids?: string[]
  addresses?: Addresses
  status_display?: string
  detail_url?: string
  apply_url?: string
  job_url?: string
  salary?: Salary
  features?: string[]
  packages?: string[]
  schema_job_posting?: string
  is_salary_visible?: boolean
  created?: DateType
  modified?: DateType
  closed?: DateType
  published?: DateType
  refreshed?: DateType
  applied?: string[]
  candidate?: string[]
  is_applied?: boolean
  is_followed?: boolean
  is_blacklisted?: boolean
  is_viewed?: boolean
  content_arr?: string[]
  requirements_arr?: string[]
  responsibilities_arr?: string[]
  slug?: string
  image_thumbnail?: string
  other_supports?: any,
  blog_tags?: string,
  blog_posts?: string[],
  sidebar_image_banner_url?: string,
  sidebar_image_link?: string,
  contract_types_str?: string
  contract_types_ids?: Array<number>
}

export const JOB_DISPLAY_STATUS_OPEN: string = "Open";
export const JOB_DISPLAY_STATUS_CLOSED: string = 'Closed'
export const JOB_DISPLAY_STATUS_IN_REVIEW: string = "Review"
export const JOB_DEFAULT_PARAMS: string[] = [
  'id',
  'title',
  'content',
  'benefits',
  'contract_types_str',
  'contract_types_ids',
  'requirements',
  'salary',
  'responsibilities',
  'company',
  'skills_arr',
  'skills_ids',
  'experiences_str',
  'experiences_ids',
  'experiences_arr',
  'job_types_str',
  'job_types_arr',
  'job_types_ids',
  'job_levels_str',
  'job_levels_ids',
  'addresses',
  'detail_url',
  'job_url',
  'modified',
  'refreshed',
  'slug',
  'is_applied',
  'is_followed',
  'meta_title',
  'meta_description',
  'meta_keywords',
  'schema_job_posting',
  'features',
  'other_supports',
  'recruiment_process',
  'status_display',
  'image_thumbnail',
  'blog_tags',
  'blog_posts',
  'sidebar_image_banner_url',
  'sidebar_image_link'
]
